"use client";
import {
  Box,
  Button,
  Container,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useRef } from "react";
import { useRouter } from "@/i18n/routing";
import classes from "./paymentconfirmation.module.css";
import { Print } from "@mui/icons-material";
import { useReactToPrint } from "react-to-print";
import { useGetApplicationQuery, useGetCustomerQuery } from "@/lib/redux";
import {
  GET_PRODUCT_APPLICATION,
  IMAGES,
  PRODUCTS,
  PRODUCTS_LIST,
} from "@/lib/constants";
import Image from "next/image";

const Paymentconfirmation = ({ amount, date, transaction_Id, txn_status }) => {
  const { data: applicationData, isLoading: fetchingApplication } =
    useGetApplicationQuery();
  const { data: customerData, isLoading: fetchingCustomer } =
    useGetCustomerQuery();
  const productApplication = GET_PRODUCT_APPLICATION(
    PRODUCTS.PL,
    applicationData?.data
  );
  const componentRef = useRef();
  const router = useRouter();
  const marginTop = "50px";
  const marginRight = "50px";
  const marginBottom = "50px";
  const marginLeft = "50px";
  const getPageMargins = () => {
    return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important; }`;
  };
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <Paper
        elevation={9}
        sx={{ px: 2, display: "flex", alignItems: "center" }}
      >
        <Stack ml={2}>
          <Image
            src={IMAGES.navbarLogo}
            alt="hero fincorp"
            height={150}
            width={150}
          />
        </Stack>
        <Container sx={{ textAlign: "center", mr: 4 }}>
          <Typography variant="h5" sx={{ fontWeight: "400", color: "#479650" }}>
            Payment Status
          </Typography>
        </Container>
      </Paper>
      <Container sx={{ mt: 3 }}>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            onClick={handlePrint}
            sx={{
              border: " 2px solid #479650",
              background: "#fff",
              color: "#000",
              padding: "5px 30px",
              my: 2,
              fontWeight: "bold",
              "&:hover": {
                background: " #479650",
                color: "#fff",
              },
            }}
          >
            <Print /> Print Receipt
          </Button>
          <Button
            variant="contained"
            sx={{
              ml: 2,
              border: " 2px solid #479650",
              background: "#fff",
              color: "#000",
              padding: "5px 30px",
              my: 2,
              fontWeight: "bold",
              "&:hover": {
                background: " #479650",
                color: "#fff",
              },
            }}
            onClick={() => router.push("/")}
          >
            Make Another Payment
          </Button>
          <Button
            variant="contained"
            sx={{
              ml: 2,
              border: " 2px solid #479650",
              background: "#fff",
              color: "#000",
              padding: "5px 30px",
              my: 2,
              fontWeight: "bold",
              "&:hover": {
                background: " #479650",
                color: "#fff",
              },
            }}
            onClick={() => router.push("/")}
          >
            Back to Dashboard
          </Button>
        </Box>
        <TableContainer sx={{ padding: "15px" }}>
          <Table ref={componentRef} sx={{ border: "1px solid black" }}>
            <style>{getPageMargins()}</style>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{ border: "1px solid black" }}
                  align="center"
                  colSpan={3}
                >
                  <Image
                    src={IMAGES.navbarLogo}
                    alt="hero fincorp"
                    height={150}
                    width={150}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{ border: "1px solid black" }}
                  align="center"
                  colSpan={3}
                >
                  Receipt of your online payment
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="left" sx={{ border: "1px solid black" }}>
                  Application Id
                </TableCell>
                <TableCell align="left" sx={{ border: "1px solid black" }}>
                  {productApplication?.appId}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left" sx={{ border: "1px solid black" }}>
                  Customer Name
                </TableCell>
                <TableCell align="left" sx={{ border: "1px solid black" }}>
                  <Typography textTransform={"capitalize"}>
                    {customerData?.data?.firstName?.toLowerCase()}{" "}
                    {customerData?.data?.lastName?.toLowerCase()}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left" sx={{ border: "1px solid black" }}>
                  Product
                </TableCell>
                <TableCell align="left" sx={{ border: "1px solid black" }}>
                  {PRODUCTS_LIST[productApplication?.product_type]}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left" sx={{ border: "1px solid black" }}>
                  <strong>Total Amount Paid</strong>
                </TableCell>
                <TableCell align="left" sx={{ border: "1px solid black" }}>
                  <strong>Rs. {amount}</strong>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left" sx={{ border: "1px solid black" }}>
                  Transaction Id
                </TableCell>
                <TableCell align="left" sx={{ border: "1px solid black" }}>
                  <Typography>{transaction_Id}</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left" sx={{ border: "1px solid black" }}>
                  Transaction Date Time
                </TableCell>
                <TableCell align="left" sx={{ border: "1px solid black" }}>
                  {date?.toLocaleString()}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left" sx={{ border: "1px solid black" }}>
                  <strong>Transaction Status</strong>
                </TableCell>
                <TableCell align="left" sx={{ border: "1px solid black" }}>
                  <strong>
                    {txn_status === "TXN_SUCCESS" ? "Success" : "Failed"}
                  </strong>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{ border: "1px solid black" }}
                  colSpan={3}
                >
                  Disclaimer: This is a system generated statement, hence does
                  not require signature
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {txn_status === "TXN_SUCCESS" ? (
          ""
        ) : (
          <Container sx={{ textAlign: "center", mb: 5 }}>
            <Button
              className={classes.submitButton}
              onClick={() => router.push("/")}
            >
              Retry Payment
            </Button>
          </Container>
        )}
      </Container>
    </>
  );
};

export default Paymentconfirmation;
